import clsx from "clsx";
import React from "react";
import { PaginationButton } from "../PaginationButton/PaginationButton";
import { Label } from "../types/labels";
import styles from "./SliderControls.module.scss";
import { BackgroundColor } from "../Backgrounds/background";

export type SliderControlsLabels = {
  goToPage: Label;
  previous: Label<string>;
  next: Label<string>;
  counterSeparator: Label;
};

export const defaultLabels: SliderControlsLabels = {
  goToPage: "Go to page",
  previous: "Previous",
  next: "Next",
  counterSeparator: "of"
};

export type SliderControlsProps = {
  totalPages: number;
  currentSlideIndex: number;
  isBeginning: boolean;
  isEnd: boolean;
  prevSlide: () => void;
  nextSlide: () => void;
  labels: SliderControlsLabels;
  className?: string;
  variantColor?: BackgroundColor;
};

export const SliderControls: React.FC<SliderControlsProps> = ({
  totalPages,
  currentSlideIndex,
  isBeginning,
  isEnd,
  nextSlide,
  prevSlide,
  labels,
  className,
  variantColor = "neutral05"
}) => {
  return (
    <div
      className={clsx(styles.controls, className, {
        [styles.variantGray]: variantColor == "neutral05",
        [styles.variantWhite]: variantColor == "white",
        [styles.variantTitanium]: variantColor == "titanium"
      })}
    >
      <div className={styles.controlsLeft}>
        <div className={styles.scrollbar} aria-hidden={true}>
          <div
            className={styles.scrollbarStepActive}
            style={{
              width: `calc(100% / ${totalPages})`,
              transform: `translateX(calc(${currentSlideIndex} * 100%))`
            }}
          ></div>
          <div className={styles.scrollbarStep}></div>
        </div>
        <div className={styles.totalPageser}>
          {currentSlideIndex + 1} {labels.counterSeparator} {totalPages}
        </div>
      </div>
      <div className="swiper-pagination" />
      <div className={styles.buttons}>
        <PaginationButton
          dataContentPiece="slider_previous_button"
          arrow="left"
          disabled={isBeginning}
          onClick={prevSlide}
          aria-label={labels.previous}
          role="button"
          variant="secondary"
          inverted={variantColor == "titanium"}
        />
        <PaginationButton
          dataContentPiece="slider_next_button"
          arrow="right"
          disabled={isEnd}
          onClick={nextSlide}
          aria-label={labels.next}
          role="button"
          variant="secondary"
          inverted={variantColor == "titanium"}
        />
      </div>
    </div>
  );
};
